import { useStudioStore } from '@/store/useStudioStore';
import { cn } from '@/lib/utils';
import { Icon } from '@iconify/react';
import { trackStudioEvent } from '@/lib/studioTracking';

/** 项目设置触发按钮组件 */
export const StudioSettingsButton = () => {
  const { isSettingsOpen, setSettingsOpen } = useStudioStore();

  const handleOpen = () => {
    if (!isSettingsOpen) {
      trackStudioEvent('studio_settings_open', {
        entrySource: 'settings_button',
        defaultTab: useStudioStore.getState().activeSettingsTab,
      });
    }
    setSettingsOpen(true);
  };

  return (
    <button
      title="Setting"
      onClick={handleOpen}
      className={cn(
        'text-muted-foreground/60 hover:text-foreground flex h-[36px] w-[36px] cursor-pointer items-center justify-center rounded-[9px] border border-black/5 bg-white text-[14px] transition-all hover:border-[rgba(109,40,217,0.3)] hover:bg-[rgba(109,40,217,0.05)] hover:text-[#6D28D9]',
        isSettingsOpen && 'border-[#6D28D9]/30 bg-[#6D28D9]/5 text-[#6D28D9]',
      )}
    >
      <Icon icon="fa6-solid:sliders" />
    </button>
  );
};
